import * as tslib_1 from "tslib";
import { ElementRef, OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, FormControl, Validators, } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material/expansion';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { ModalService, PermissionService, RoleService, } from '@services';
import UiValidators, { UI_NAME_MAX_LENGTH } from '@validators';
import difference from 'lodash-es/difference';
import intersection from 'lodash-es/intersection';
import keyBy from 'lodash-es/keyBy';
import uniqBy from 'lodash-es/uniqBy';
import { BehaviorSubject, Subject, } from 'rxjs';
import { debounceTime, finalize, map, startWith, switchMap, takeUntil, tap, } from 'rxjs/operators';
var RoleModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RoleModalComponent, _super);
    function RoleModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.elevatedPermissions = ['Settings.Edit', 'Roles.Edit', 'Users.Edit', 'Robots.Edit', 'Machines.Edit'];
        _this.actions = ['View', 'Edit', 'Create', 'Delete'];
        _this.loading$ = new BehaviorSubject(false);
        _this.didExpandWarning = false;
        _this.globalActionChecked = {};
        _this.folderActionChecked = {};
        _this.groupChecked = {};
        _this.permissions$ = new BehaviorSubject([]);
        _this.permissionGroups$ = new BehaviorSubject([]);
        _this.globalPermissionGroups$ = _this.permissionGroups$.pipe(map(function (groups) { return groups.filter(function (g) { return g.scope === 'Global'; }); }));
        _this.folderPermissionGroups$ = _this.permissionGroups$.pipe(map(function (groups) { return groups.filter(function (g) { return g.scope === 'Folder'; }); }));
        _this._roleService = _this._injector.get(RoleService);
        _this._permissionsService = _this._injector.get(PermissionService);
        _this._modalService = _this._injector.get(ModalService);
        _this._translateService = _this._injector.get(TranslateService);
        _this._destroyed$ = new Subject();
        _this._registerForm = function (disabledPermissions) {
            var permissionGranted = keyBy(_this.context.data.permissions.filter(function (p) { return p.isGranted; }), function (p) { return p.name; });
            var controls = _this.permissions$.value.reduce(function (ctrls, _a) {
                var permName = _a.name;
                ctrls[permName] = new FormControl({
                    value: !!permissionGranted[permName],
                    disabled: !_this.context.data.isEditable || disabledPermissions.has(permName),
                });
                return ctrls;
            }, {});
            _this.form = _this._injector.get(FormBuilder).group(tslib_1.__assign({}, controls, { 'name': [
                    _this.context.data.name,
                    Validators.compose([
                        UiValidators.required(),
                        Validators.maxLength(UI_NAME_MAX_LENGTH),
                    ]),
                ] }));
            _this.form
                .valueChanges
                .pipe(startWith(null), debounceTime(50), switchMap(function () { return _this.permissionGroups$; }), takeUntil(_this._destroyed$)).subscribe(function (groups) {
                groups.forEach(_this._computePermissionGroupCheckboxState);
                _this.actions.forEach(function (a) {
                    _this._computeActionCheckboxState(a, true, groups);
                    _this._computeActionCheckboxState(a, false, groups);
                });
                _this._cd.detectChanges();
            });
        };
        _this._computePermissionGroupCheckboxState = function (_a) {
            var group = _a.name;
            var checked = _this.permissions$.value
                .filter(function (_a) {
                var name = _a.name;
                return _this._boxEnabled(name) &&
                    _this._boxChecked(name) &&
                    name.startsWith(group);
            })
                .length;
            _this.groupChecked[group] = _this._computeCheckedState(checked, _this.actions.length);
        };
        _this._computeActionCheckboxState = function (action, folderPermissions, groups) {
            var checked = _this.permissions$.value
                .filter(function (_a) {
                var name = _a.name, scope = _a.scope;
                return _this._boxEnabled(name) &&
                    _this._boxChecked(name) &&
                    name.endsWith(action) &&
                    scope === 'Folder' === folderPermissions;
            })
                .length;
            var actionSet = folderPermissions ? _this.folderActionChecked : _this.globalActionChecked;
            var folderPermissionsCount = groups.filter(function (g) { return g.scope === 'Folder'; }).length;
            var permissionCount = folderPermissions ? folderPermissionsCount
                : (groups.length - folderPermissionsCount);
            actionSet[action] = _this._computeCheckedState(checked, permissionCount);
        };
        _this._submitData = function () {
            _this.loading$.next(true);
            var payload = {
                id: _this.context.data.id,
                name: _this.form.get('name').value,
                displayName: _this.form.get('name').value,
                permissions: _this.permissions$.value
                    .filter(function (p) { return _this._boxEnabled(p.name); })
                    .map(function (p) { return (tslib_1.__assign({}, p, { isGranted: _this._boxChecked(p.name) })); }),
            };
            var req = _this.context.isNewEntry
                ? _this._roleService.add(payload)
                : _this._roleService.update(_this.context.data.id, payload);
            req.pipe(finalize(function () { return _this.loading$.next(false); })).subscribe(function (role) {
                _this._dialogRef.close({
                    type: _this.context.isNewEntry ? 1 /* Add */ : 2 /* Update */,
                    data: _this.context.isNewEntry ? role : _this.context.data,
                });
            });
        };
        return _this;
    }
    Object.defineProperty(RoleModalComponent.prototype, "isWarningVisible", {
        get: function () {
            var _this = this;
            var checked = this.permissions$.value.filter(function (p) { return _this._boxChecked(p.name); });
            var folderPermissionsChecked = checked.filter(function (p) { return p.scope === 'Folder'; }).length;
            var globalPermissionsChecked = checked.filter(function (p) { return p.scope === 'Global'; }).length;
            return folderPermissionsChecked && globalPermissionsChecked;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoleModalComponent.prototype, "shouldReviewWarnings", {
        get: function () {
            return this.form && this.form.dirty && this.isWarningVisible && !this.didExpandWarning;
        },
        enumerable: true,
        configurable: true
    });
    RoleModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.context.data.permissions = this.context.data.permissions || [];
        if (this.context.isNewEntry) {
            this.context.data.isEditable = true;
        }
        this._permissionsService.getPermissions()
            .pipe(map(function (permissions) {
            var groups = uniqBy(permissions
                .map(function (p) { return (tslib_1.__assign({}, p, { name: p.name.split('.')[0] })); })
                .map(function (p) { return ({
                name: p.name,
                scope: p.scope,
                localName: "page_" + p.name.toLowerCase(),
            }); }), function (g) { return g.name; });
            var groupsByName = keyBy(groups, function (g) { return g.name; });
            var enabledPermissions = new Set(permissions.map(function (p) { return p.name; }));
            var disabledPermissions = new Set();
            groups.forEach(function (_a) {
                var groupName = _a.name;
                _this.actions.forEach(function (action) {
                    var permName = groupName + '.' + action;
                    if (!enabledPermissions.has(permName)) {
                        permissions.push({
                            isGranted: false,
                            name: permName,
                            scope: groupsByName[groupName].scope,
                        });
                        disabledPermissions.add(permName);
                    }
                });
            });
            _this.permissionGroups$.next(groups.sort(function (a, b) { return a.localName.localeCompare(b.localName); }));
            _this.permissions$.next(permissions);
            return disabledPermissions;
        }), tap(this._registerForm), takeUntil(this._destroyed$)).subscribe();
    };
    RoleModalComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    RoleModalComponent.prototype.reviewWarning = function () {
        this.warning.open();
        this.dialog.nativeElement.scrollTop = 0;
    };
    RoleModalComponent.prototype.onSubmit = function () {
        var _this = this;
        var originalPerms = this.context.data.permissions.filter(function (p) { return p.isGranted; }).map(function (p) { return p.name; });
        var newPerms = this.permissions$.value
            .filter(function (_a) {
            var name = _a.name;
            return _this._boxEnabled(name) && _this._boxChecked(name);
        })
            .map(function (p) { return p.name; });
        var anyElevatedPermissions = intersection(difference(newPerms, originalPerms), this.elevatedPermissions).length > 0;
        if (anyElevatedPermissions) {
            this._modalService.onConfirm(null, function () { return _this._submitData(); }, function () { }, this._translateService.instant('role_modal_form_confirm_elevated_permissions'));
        }
        else {
            this._submitData();
        }
    };
    RoleModalComponent.prototype.toggleAction = function (action, folderPermissions) {
        this._togglePermissions(function (p) {
            return p.name.endsWith(action) &&
                (folderPermissions == null ||
                    p.scope === 'Folder' === folderPermissions);
        });
    };
    RoleModalComponent.prototype.togglePermissionGroup = function (permissionGroup) {
        this._togglePermissions(function (p) { return p.name.startsWith(permissionGroup.name); });
    };
    RoleModalComponent.prototype._togglePermissions = function (predicate) {
        var _this = this;
        var toToggle = this.permissions$.value.filter(predicate);
        var nextValue = toToggle.some(function (p) { return !_this._boxChecked(p.name); });
        toToggle.forEach(function (p) { return _this.form.get([p.name]).setValue(nextValue); });
        this.form.markAsDirty();
    };
    RoleModalComponent.prototype._computeCheckedState = function (checked, total) {
        return checked === 0 ? 'unchecked'
            : checked === total ? 'checked'
                : 'indeterminate';
    };
    RoleModalComponent.prototype._boxEnabled = function (key) {
        return this.form.get([key]).enabled;
    };
    RoleModalComponent.prototype._boxChecked = function (key) {
        return this.form.get([key]).value;
    };
    return RoleModalComponent;
}(UiModalComponent));
export { RoleModalComponent };
